module.exports = __webpack_public_path__ + "img/hbk_tmd.8212a37a.svg";